import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Identificás el Anzuelo',
  desc: 'Entendés por qué tu ex te escribe lo que te escribe y qué reacción está buscando.'
}, {
  title: 'Aplicás el Filtro',
  desc: 'Separá el drama (ruido) del dato (hijos, horarios, salud).'
}, {
  title: 'Ejecutás el Blindaje',
  desc: 'Respondés usando nuestras fórmulas de comunicación aséptica y bloqueás el reingreso del conflicto.'
}];
export function HowItWorks() {
  return <section className="bg-[#17304F] py-24 px-6" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white" data-id="element-154">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="relative" data-id="element-155">
          {/* Vertical line connecting steps on desktop */}
          <div className="hidden md:block absolute left-8 top-8 bottom-8 w-0.5 bg-orange-200" data-id="element-156"></div>

          <div className="space-y-8" data-id="element-157">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative flex flex-col md:flex-row gap-6 md:gap-8 items-start" data-id="element-158">
                <div className="flex-shrink-0 w-16 h-16 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-playfair font-bold text-2xl border-4 border-white shadow-sm z-10" data-id="element-159">
                  {index + 1}
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex-1 w-full" data-id="element-160">
                  <h4 className="text-xl font-bold text-navy mb-2" data-id="element-161">
                    {step.title}
                  </h4>
                  <p className="text-slate-600 text-lg" data-id="element-162">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}